import './Passwd.svelte.css';
/* src/Passwd.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	attr,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	set_input_value,
	space
} from "./_snowpack/pkg/svelte/internal.js";

import { createEventDispatcher } from './_snowpack/pkg/svelte.js';

function create_fragment(ctx) {
	let input0;
	let t;
	let input1;
	let mounted;
	let dispose;

	return {
		c() {
			input0 = element("input");
			t = space();
			input1 = element("input");
			attr(input0, "placeholder", "Password");
			attr(input0, "class", "passwd-input svelte-lvbx2f");
			attr(input1, "type", "checkbox");
			attr(input1, "class", "passwd-visable svelte-lvbx2f");
		},
		m(target, anchor) {
			insert(target, input0, anchor);
			set_input_value(input0, /*pass*/ ctx[0]);
			insert(target, t, anchor);
			insert(target, input1, anchor);
			input1.checked = /*visable*/ ctx[1];

			if (!mounted) {
				dispose = [
					listen(input0, "input", /*input0_input_handler*/ ctx[4]),
					listen(input0, "input", /*onUpdate*/ ctx[2]),
					listen(input1, "change", /*input1_change_handler*/ ctx[5]),
					listen(input1, "input", /*onVisable*/ ctx[3])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*pass*/ 1 && input0.value !== /*pass*/ ctx[0]) {
				set_input_value(input0, /*pass*/ ctx[0]);
			}

			if (dirty & /*visable*/ 2) {
				input1.checked = /*visable*/ ctx[1];
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(input0);
			if (detaching) detach(t);
			if (detaching) detach(input1);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	const dispatch = createEventDispatcher();
	let pass = '';
	let visable = true;

	function onUpdate(e) {
		dispatch('update', { value: e.target.value });
	}

	function onVisable(e) {
		dispatch('visable', { value: e.target.checked });
	}

	function input0_input_handler() {
		pass = this.value;
		$$invalidate(0, pass);
	}

	function input1_change_handler() {
		visable = this.checked;
		$$invalidate(1, visable);
	}

	return [
		pass,
		visable,
		onUpdate,
		onVisable,
		input0_input_handler,
		input1_change_handler
	];
}

class Passwd extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Passwd;